import { useState } from "react";
import GEO from "./paraguayGeo.json";

const [, , VW, VH] = GEO.vb.split(" ").map(Number);
const TILDES = { "ALTO PARANA": "Alto Paraná", ITAPUA: "Itapúa", CAAGUAZU: "Caaguazú", CAAZAPA: "Caazapá", GUAIRA: "Guairá", CONCEPCION: "Concepción", PARAGUARI: "Paraguarí",
  CANINDEYU: "Canindeyú", BOQUERON: "Boquerón", ASUNCION: "Asunción", "ÑEEMBUCU": "Ñeembucú", NEEMBUCU: "Ñeembucú" };
const nombre = (n) => TILDES[n] || n.toLowerCase().replace(/(^|\s)\S/g, (x) => x.toUpperCase());

/** Mapa 3D de Paraguay: al apuntar un departamento, se eleva y su nombre sale del mapa en 3D. */
export const Mapa3D = () => {
  const [sel, setSel] = useState(null);
  const marcar = (e, n) => {
    const b = e.currentTarget.getBBox();
    setSel({ n, x: ((b.x + b.width / 2) / VW) * 100, y: ((b.y + b.height / 2) / VH) * 100, d: e.currentTarget.getAttribute("d") });
  };
  return <div className="ins-mapa" data-testid="inicio-mapa-3d" onMouseLeave={() => setSel(null)}>
    <div className="ins-mapa-escena">
      {[6, 5, 4, 3, 2, 1].map((z) => <svg key={z} viewBox={GEO.vb} className="ins-capa" style={{ "--z": z }} aria-hidden>
        {GEO.deps.map((d) => <path key={d.n} d={d.d} />)}</svg>)}
      <svg viewBox={GEO.vb} className="ins-tope" role="img" aria-label="Mapa de Paraguay">
        <defs><linearGradient id="insG" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#c9a24a" /><stop offset=".45" stopColor="#5e8f3e" /><stop offset="1" stopColor="#1f7a4d" /></linearGradient></defs>
        {GEO.deps.map((d) => <path key={d.n} d={d.d} fill="url(#insG)" className={sel?.n === d.n ? "sel" : ""} onMouseEnter={(e) => marcar(e, d.n)} onClick={(e) => marcar(e, d.n)} data-testid={`mapa-dep-${d.n.replace(/\s+/g, "-").toLowerCase()}`} />)}
      </svg>
      {sel && <svg key={sel.n} viewBox={GEO.vb} className="ins-elevado" aria-hidden><path d={sel.d} /></svg>}
      {sel && <div key={`e-${sel.n}`} className="ins-etq" style={{ left: `${sel.x}%`, top: `${sel.y}%` }} data-testid="mapa-dep-nombre">
        <span className="ins-etq-palo" /><span className="ins-etq-txt">{nombre(sel.n)}</span>
      </div>}
    </div>
    <p className="ins-mapa-txt">{sel ? nombre(sel.n) : "Paraguay · 17 departamentos + Asunción"}</p>
  </div>;
};
